import { Component, ElementRef, Input, NgZone, OnInit, Renderer2, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../models';
import { BreadCrumbService, MenuService } from '../../services';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { ActiveChild } from '../../interfaces/active-child.interface';
import { CtViewComponent } from '../ct-view/ct-view.component';
import { breakpoints } from "../../environments/environment.breakpoints";

@Component({
  selector: 'ct-menu',
  templateUrl: './ct-menu.component.html',
  styleUrls: ['./ct-menu.component.css']
})

export class CtMenuComponent extends CtrlBaseComponent implements OnInit {
  @Input() profileView;
  @Input() loggedUser: User;
  // public : 
  private nodes: any;
  private maxColumnRows: number;
  private nodeActions: any[];
  private roles: any;
  private selectedRole: any;
  private isSideOptionsHidden: boolean;
  private eventFunction: any;
  public activeChild: ActiveChild;
  private componentService: any;
  public windowSize: any;
  private isMobile: boolean;
  private isTablet: boolean;
  private isDesktop: boolean;
  private isLogoutHidden: boolean;
  private isOpen: boolean = true;
  private isCooldownActive = false;
  private menuItemToIdMap : Map<string,string> = new Map<string,string>();

  getIsMobile(): boolean { return this.isMobile }
  setIsMobile(isMobile: boolean): void { this.isMobile = isMobile }

  getIsTablet(): boolean { return this.isTablet }
  setIsTablet(isTablet: boolean): void { this.isTablet = isTablet }

  getIsDesktop(): boolean { return this.isDesktop }
  setIsDesktop(isDesktop: boolean): void { this.isDesktop = isDesktop }


  getIsLogoutHidden(): boolean { return this.isLogoutHidden }
  setIsLogoutHidden(isLogoutHidden: boolean): void { this.isLogoutHidden = isLogoutHidden }

  constructor(private ngZone: NgZone, private router: Router, 
    public menuService: MenuService, 
    private el: ElementRef) {
    super();
    this.isSideOptionsHidden = true;
    this.isDesktop = false;
    this.isMobile = false;
    this.isTablet = false;
    this.isLogoutHidden = true;
    this.setIsOpen(true);
  }


  ngOnInit() {   
    this.onResize();
    this.menuService.getMenuOptions().subscribe(data => {
      this.roles = data;
      this.getSelectedAdn();
    });
    this.menuService.setMenuComponent(this);
  }



  @HostListener('window:resize', ['$event'])
  onResize() {

    const isLargeSize = window.innerWidth >= breakpoints.L;
    const isMediumSize = window.innerWidth < breakpoints.L && window.innerWidth >= breakpoints.M;
    const isSmallSize = window.innerWidth >= breakpoints.S && window.innerWidth < breakpoints.M;

    if (isLargeSize) {
      this.isLogoutHidden = true;
      this.isDesktop = true;
      this.isMobile = false;
      this.isTablet = false;
      this.setIsOpen(true);
    }

    if (isMediumSize) { 
      this.isLogoutHidden = true;
      this.isDesktop = false;
      this.isMobile = false;
      this.isTablet = true;
      this.setIsOpen(false);
    }

    if (isSmallSize) {
      this.isLogoutHidden = false;
      this.isDesktop = false;
      this.isMobile = true;
      this.isTablet = false;
      this.setIsOpen(false);
    }

  }

  getMenuItemId(menuItemName : string) {
    return this.menuItemToIdMap.get(menuItemName);
  }

  toggleSideOptions() {
    if (this.isSideOptionsHidden)
      this.isSideOptionsHidden = false;
    else
      this.isSideOptionsHidden = true;
  }

  createEvent() {

    if (!this.eventFunction)
      this.eventFunction = this.onClickClose.bind(this);

    document.addEventListener('click', this.eventFunction, false);

  }

  onClickClose(event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.hideMenu();
    }
  }

  ngOnDestroy() {
    try {
      this.hideMenu();
    } catch (e) {

    }
  }

  getSelectedAdn(): void {
    let allRoleNodes = [];
    let urlSelected = this.router.url.split('/');

    this.getRoles().forEach((node) => {
      node.childs.forEach((child) => {

        child.childs.forEach((childOption) => {
          //Select the option in the menu that matches the loaded view.
          if(childOption.navigateTo == urlSelected[urlSelected.length-1] ){
            childOption.isActive = true;
          }
        });

        allRoleNodes.push(child);
      });
    })

    allRoleNodes = this.cleanNodes(allRoleNodes);
    console.log(
      allRoleNodes
    );
    this.setNodes(allRoleNodes);
  }

  private cleanNodes(allRoleNodes: any[]): any {
    return allRoleNodes.map(menuItem => ({
      ...menuItem,
      childs: this.removeDuplicates(menuItem.childs)
  }));
  }

  private removeDuplicates(childs: any) {
    const unique = {};

    childs.forEach((child, index) => {
        if (unique[child.text]) {
            if (child.IsVisible || !unique[child.text].IsVisible) {
                unique[child.text] = child;
                this.menuItemToIdMap.set(child.text, `${child.text}_${index}`);
            }
        } else {
            this.menuItemToIdMap.set(child.text, `${child.text}_${index}`);
            unique[child.text] = child;
        }
    });
    return Object.values(unique);
  }

  navigateTo(route: any, nodeInd: number, childInd: number) {
    if(!this.isCooldownActive){
    if (this.activeChild) {
      let currentNode = this.nodes[this.activeChild.nodeIndex].childs[this.activeChild.childIndex];
      if(currentNode) currentNode.isActive = false;
    }else{
      this.getNodes().forEach((node) => {
        node.childs.forEach((child) => {
            child.isActive = false;
      });
    })
    }
    route.isActive = true;
    this.activeChild = {} as ActiveChild;
    this.activeChild.child = route;
    this.activeChild.nodeIndex = nodeInd;
    this.activeChild.childIndex = childInd;
    if(!this.getIsDesktop()){
        this.hideMenu();
    }
    this.menuService.navigateTo(route.text, route.navigateTo);
    this.startCooldown(); 
  }
  }

  navigateToAction(route: any, event:any) {

    if(event){
      event.stopPropagation();
    }
    let childs = this.getChildNodeIndex(route.OptNavigate);

    this.navigateTo(childs[0], childs[1], childs[2]);
    
    setTimeout(() => {
      let componentRef: CtrlBaseComponent = this.utilService.getComponentRef(route.OptNavigate);

      if (route.Action && componentRef) {

        let actions = route.Action.split(".")
        componentRef['view'].onInitActions(actions[0], actions[1]);

      }
    }, 1000);
  }

  startCooldown(){
    this.isCooldownActive = true;
    setTimeout(() => {
      this.isCooldownActive = false;
    }, 700); //setea un timeOut a la navegacion para evitar que se haga un overlap de las vistas.
  }

  userProfile() {
    this.router.navigate([this.profileView]);
  }

  logOut() {
    this.menuService.logOut();
  }

  showMenu() {
    this.setIsOpen(true);
  }

  hideMenu() {
    this.setIsOpen(false);
  }

  getChildNodeIndex(view: String) {
    let nodo;
    let indexNodo;
    let indexRol;
    this.getNodes().forEach((node, nodeindex) => {

      node.childs.forEach((child, index) => {

        if (child.navigateTo == view) {
          nodo = child;
          indexRol = nodeindex;
          indexNodo = index;
        }
      });
    })
    return [nodo, indexRol, indexNodo];

  }

  saveRemoveFav() {
    //console.log('fav');
    this.menuService.addToFavorites(9);
    return true;
  }

  getIfOptionHidden(child : any): boolean {
    if(child.IsVisible) return false;
    return true;
  }


  getNodes() { return this.nodes };
  getMaxColumnRow() { return this.maxColumnRows }
  getNodeActions() { return this.nodeActions }
  getRoles() { return this.roles }
  getSelectedRole() { return this.selectedRole };
  getIsOpen(): boolean { return this.isOpen }

  
  setIsOpen(isOpen: boolean ): boolean { return this.isOpen = isOpen }
  setNodes(nodes: any[]) { this.nodes = nodes };
  setMaxColumnRow(maxColumnRows: number) { this.maxColumnRows = maxColumnRows }
  setNodeActions(nodeActions: any[]) { this.nodeActions = nodeActions }
  setRoles(roles: any) { this.roles = roles };
  setSelectedRole(selectedRole: any) { this.selectedRole = selectedRole };

}
